




















































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import SignUpForm from "@/models/forms/SignUpForm";
import Cognito from "@/cognito/index";
import {
  ValidationObserver,
  ValidationObserverInstance,
  install
} from "vee-validate";
import { getAdress, getStates, getCities } from "@/services/address";
import { Estado } from "@/services/models/adress";
import { getInstitutions } from "@/services/institutions";
import Institution from "@/services/models/institutions";
import { createUser } from "@/services/user";
import LoaderMixin from "@/mixins/loader";
import NotificationMixin from "@/mixins/notification";
import {
  setCognitoUser,
  logOut,
  getSession
} from "../../services/authentication";
import { CognitoUserSession } from "amazon-cognito-identity-js";

import moment from "moment";

@Component({
  components: {}
})
export default class SignUp extends mixins(LoaderMixin, NotificationMixin) {
  private form: SignUpForm;
  private cognito: Cognito;
  private valid: boolean;

  private menu: boolean = false;
  private date: string = "";
  private secondPassword: string = "";

  private requiredRule: any;
  private emailRules: any;
  private passwrodRules: any;
  private dateRules: any;

  private institutions: Institution[] = [];
  private institutionsNames: string[] = [];

  private states: Estado[] = [];
  private siglas: string[] = [];
  private selectedState: string;

  private cities: string[] = [];
  private selectedCity: string;

  constructor() {
    super();

    this.form = {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      birthDate: "",
      phoneNumber: "",
      institution: "",
      type: "",
      cep: "",
      street: "",
      streetNumber: "",
      state: "",
      city: "",
      neighborhood: "",
      complement: ""
    };

    this.cognito = new Cognito();
    this.valid = true;

    this.selectedState = "";
    this.secondPassword = "";
    this.selectedCity = "";

    this.requiredRule = [
      // @ts-ignore
      v => !!v || "Campo obrigatório"
    ];

    this.emailRules = [
      // @ts-ignore
      v => !!v || "E-mail é obrigatório",
      // @ts-ignore
      v => /.+@.+/.test(v) || "Digite um email válido"
    ];

    this.passwrodRules = [
      // @ts-ignore
      v => !!v || "Campo obrigatório",
      // @ts-ignore
      v => (v && v.length >= 6) || "A senha deve conter pelo menos 6 caracteres"
    ];

    this.dateRules = [
      // @ts-ignore
      v => !!v || "Campo obrigatório",
      // @ts-ignore
      v => (v && v.length >= 10) || "Data inválida",
      // @ts-ignore
      v => moment(v, 'DD-MM-YYYY').isValid() || "Data inválida"
    ]
  }

  @Watch("form.cep")
  onCepChanged(value: string, oldValue: string) {
    if (value.length === 8) {
      this.populateFields();
    }
  }

  @Watch("selectedState")
  onSelectedStateChanged(value: string, oldValue: string) {
    if (value) {
      this.selectedCity = "";

      let codigoEstado = this.states.filter(state => state.sigla == value)[0]
        .id;

      this.showLoader();

      getCities(codigoEstado).then(cities => {
        this.cities = cities;

        this.selectedCity = this.form.city;
        this.hideLoader();
      });
    }
  }

  @Watch("selectedCity")
  onSelectedCityChanged(value: string, oldValue: string) {}

  created() {
    getStates().then(states => {
      this.states = states;
      this.siglas = states.map(state => state.sigla).sort();
    });
    getInstitutions().then(institutions => {
      this.institutions = institutions;
      this.institutionsNames = institutions.map(
        institution => institution.nome
      );
    });
  }

  private async addUser() {
    // @ts-ignore
    if (this.$refs.form.validate() && this.validatePassword()) {
      this.showLoader();

      this.signUp()
        .then(result => {
          result = result.data;
          if (result.success) {
            this.$store.dispatch("setUser", result.data);
            this.signUpCognito();
          } else {
            this.hideLoader();
            if (result.code === "user_exists") {
              this.showErrorNotification(
                "Já existe um usuário com este e-mail."
              );
            } else {
              this.showServerErorNotification();
            }
          }
        })
        .catch(err => {
          this.hideLoader();
          this.showServerErorNotification();
        });
    }
  }

  private signUpCognito() {
    this.cognito
      .signUp(this.form.email, this.form.password, {
        name: this.form.firstName,
        family_name: this.form.lastName,
        email: this.form.email.toLowerCase(),
        birthdate: this.parseDate(this.form.birthDate),
        phone_number: "+55" + this.form.phoneNumber,
        "custom:type": "user"
      })
      .then(async result => {
        setCognitoUser(this.form.email); //gambi

        logOut();

        this.$localStorage.set("userForm", JSON.stringify(this.form));

        this.hideLoader();

        this.$router.push("cadastro/confirmacao");
      })
      .catch(err => {
        this.hideLoader();

        if (err.code === "UsernameExistsException") {
          this.showErrorNotification("Já existe um usuário com este e-mail.");
        } else {
          this.showServerErorNotification();
        }
      });
  }

  private async signUp() {
    this.form.type = "user";
    return await createUser(this.form);
  }

  private populateFields(): void {
    this.showLoader();

    getAdress(this.form.cep).then(address => {
      this.form.street = address.logradouro;
      this.form.neighborhood = address.bairro;
      this.selectedState = address.uf;
      this.form.city = address.localidade;

      this.hideLoader();
    });
  }

  private parseDate(date: string): string {
    if (!date) {
      return null;
    }

    const [day, month, year] = date.split("/");

    return `${month.padStart(2, "0")}/${day.padStart(2, "0")}/${year}`;
  }
  private validatePassword(): boolean {
    if (this.form.password !== this.secondPassword) {
      this.showPasswordMismatchNotification();
      return false;
    }
    return true;
  }
}
